import { Autocomplete, AutocompleteProps, Chip, TextField } from "@mui/material";
import { castArray } from "lodash";
import { Tractor } from "../../../../../graphql/generated";
import { ConditionValueSelectorComponentProps } from "../../ConditionForm";
import { testIds } from "./TractorInput.testIds";
import activeOrSelected from "../../../../../utils/assets/activeOrSelected";

const TractorInput = ({
  value,
  onChange,
  tractors,
  sx,
  ...otherProps
}: ConditionValueSelectorComponentProps & {
  tractors: Pick<Tractor, "_id" | "serialNumber" | "status">[];
} & Pick<AutocompleteProps<string, true, undefined, undefined>, "sx">) => {
  // Rules saved before multiselect hold a single id, so always read a list.
  const selectedIds = castArray(value ?? []).filter(
    (id): id is string => typeof id === "string"
  );
  const selectableTractors = activeOrSelected(tractors, selectedIds);
  return (
    <Autocomplete
      data-testid={testIds.tractorInputAutocomplete}
      disablePortal
      multiple
      options={selectableTractors}
      getOptionLabel={(tractor) => tractor.serialNumber}
      renderTags={(value, getTagProps) =>
        value.map((tractor, index) => (
          <Chip
            label={tractor.serialNumber}
            {...getTagProps({ index })}
            data-testid={`${testIds.tractorInputAutocompleteTag}-${tractor.serialNumber}`}
            key={tractor._id}
          />
        ))
      }
      renderOption={(props, tractor) => (
        <li
          {...props}
          data-testid={testIds.tractorInputAutocompleteOption}
          data-value={tractor.serialNumber}
        >
          {tractor.serialNumber}
        </li>
      )}
      onChange={(event, value) => {
        onChange(value.map((tractor) => tractor._id));
      }}
      value={selectableTractors.filter((tractor) =>
        selectedIds.includes(tractor._id)
      )}
      size="small"
      renderInput={(inputProps) => (
        <TextField
          {...inputProps}
          inputProps={{
            ...inputProps.inputProps,
            "data-testid": testIds.tractorInputAutocompleteInput,
          }}
        />
      )}
      sx={{
        minWidth: 300,
        ...sx,
      }}
      {...otherProps}
    />
  );
};

export default TractorInput;
